import { Formik, Form as FormikForm } from "formik";

import { withStyles } from "@material-ui/core/styles";
import MuiCircularProgress from "@mui/material/CircularProgress";
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

import { theme } from "../../../../../styles/theme";
import { useAuth } from "../../../../../hooks/useAuth";

const StyledRadio = withStyles({
  root: {
    color: `${theme.palette.primary.light}`,
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

export const ContactTypeForm = ({ initialValues, onSubmit }) => {
  const { handleChangeTwoFactorData, twoFactorAuthData, handleLogout } =
    useAuth();

  const handleChangeContactType = (contactType) => {
    const contact = {
      selectedContactType: contactType,
    };

    handleChangeTwoFactorData(contact);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <FormikForm noValidate>
          <RadioGroup
            onChange={(e) => handleChangeContactType(e.target.value)}
            sx={{
              color: `${theme.palette.common.black}`,
              gap: "8px",
              alignItems: "center",
              display: "flex",
              margin: "32px 0",
            }}
          >
            {!!twoFactorAuthData.email && (
              <FormControlLabel
                id="radio-email"
                disabled={isSubmitting}
                value="email"
                control={<StyledRadio size="small" />}
                label={`E-mail: ${twoFactorAuthData.email}`}
                checked={twoFactorAuthData.selectedContactType === "email"}
              />
            )}
            {!!twoFactorAuthData.sms && (
              <FormControlLabel
                id="radio-sms"
                disabled={isSubmitting}
                value="sms"
                control={<StyledRadio size="small" />}
                label={`SMS: ${twoFactorAuthData.sms}`}
                checked={twoFactorAuthData.selectedContactType === "sms"}
              />
            )}
          </RadioGroup>
          <Box
            mt={4}
            display="flex"
            justifyContent="center"
            flexDirection="column"
            gap="14px"
          >
            <Button
              fullWidth
              disabled={
                (!twoFactorAuthData.email && !twoFactorAuthData.sms) ||
                isSubmitting
              }
              type="submit"
              sx={{
                backgroundColor: `${theme.palette.primary.main}`,
                color: `${theme.palette.common.white}`,
                height: 50,
                fontSize: 16,
                width: "100%",
                "&:hover": {
                  backgroundColor: `${theme.palette.primary.light}`,
                },
                "& svg": {
                  color: `${theme.palette.common.white}`,
                },
              }}
            >
              {isSubmitting ? (
                <MuiCircularProgress size={30} color="inherit" />
              ) : (
                "ENVIAR"
              )}
            </Button>
            <Button
              disableRipple
              disabled={isSubmitting}
              sx={{
                backgroundColor: "transparent",
                border: "none",
                padding: "0px",
                cursor: "pointer",
                fontSize: "16px",
                textTransform: "inherit",
                transition: "opacity 0.2s",
                "&:hover": {
                  backgroundColor: "transparent",
                  border: "none",
                  opacity: 0.9,
                },
              }}
              onClick={handleLogout}
            >
              Voltar para tela de login
            </Button>
          </Box>
        </FormikForm>
      )}
    </Formik>
  );
};
